import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GIXNGButtonsService {

  constructor() { }

  getEasyNaming(icon: string): string {
    let i = "add"; //default
    switch (icon) {
      case "profile":  i= "people";   break;
      case "profil": i= "people";
      break;
      case "login": i= "lock";   break;
      case "connect": i= "lock";      break;
      case "log-in": i= "lock";      break;
       

      case "logout":i= "lock_open";   break;       
      case "disconnect":i= "lock_open";  break;
      case "log-out": i= "lock_open";  break;
       

      default:
      return i=icon;
        break;
    }
    return i;
  }
}
